import { invoke } from '@tauri-apps/api/core';

/**
 * The export re-auth, as the host enforces it (card 39cf5e71, S12).
 *
 * `vault_export_authorize` checks the master passphrase and, when it opens the
 * vault, returns a single-use ticket that `vault_export_data` spends within a
 * minute. Without it the host refuses the export — a console
 * `invoke('vault_export_data', …)` no longer skips the prompt.
 *
 * Resolves to the ticket, or `null` for a wrong passphrase. A failing command
 * (a broken vault) also resolves `null`: not a wrong password, but neither is
 * it a licence to export. Fail closed, same as `verifyMasterPassword`.
 */
export async function authorizeVaultExport(secret) {
  if (!secret) return null;
  try {
    const ticket = await invoke('vault_export_authorize', { secret });
    return typeof ticket === 'string' && ticket !== '' ? ticket : null;
  } catch {
    return null;
  }
}
